module.exports = __webpack_public_path__ + "static/media/cwiczenia-ortograficzne-online-ws3.f17ff7fe.png";